import QueryForm from './QueryForm.vue'

QueryForm.install = app => {
  app.component(QueryForm.name, QueryForm)
}

export default QueryForm
